import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const CreateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${props =>
    props.selectLead ? 'space-between' : 'flex-start'};
  margin: ${pxToRem('20px')};
  gap: ${pxToRem('24px')};
  align-items: center;
  overflow-y: auto;
  min-height: ${pxToRem('600px')};
  //overflow-x: hidden;
  select {
    border: ${pxToRem('1px')} solid rgba(70, 122, 251, 1);
    border-radius: ${pxToRem('6px')};
    background-color: white;
    padding: ${pxToRem('16px')};
    width: ${props => (props.prefix ? '30%' : 'auto')};
    height: ${pxToRem('56px')};
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem('20px')};
`;
export const BoxContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: ${pxToRem('24px')};
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  object-fit: contain;
  border-radius: ${pxToRem('36px')};
  -webkit-backdrop-filter: blur(${pxToRem('22px')});
  backdrop-filter: blur(${pxToRem('22px')});
  border: solid ${pxToRem('2px')} #f0f0f0;
  background-color: rgba(255, 255, 255, 0.8);
  padding: ${pxToRem('8px')};
  margin: ${pxToRem('0px')} ${pxToRem('15px')};
`;

export const Box = styled.div`
  padding: ${pxToRem('12px')} ${pxToRem('58px')};
  flex-grow: 1;
  text-align: center;
  margin: ${pxToRem('5px')} ${pxToRem('10px')};

  :hover {
    cursor: pointer;
  }

  ${props =>
    props.highlight &&
    css`
      border-radius: ${pxToRem('28px')};
      background-color: ${props.theme.colors.blue.five};
    `}
`;

export const InputContainer = styled.input`
  width: 100%;
  height: ${pxToRem('56px')};
  padding: ${pxToRem('12px')} ${pxToRem('29px')} ${pxToRem('12px')}
    ${pxToRem('20px')};
  border-radius: ${pxToRem('8px')};
  border: ${props =>
    props.error
      ? `solid ${pxToRem('1px')} ${props.theme.colors.statusRed}`
      : `solid ${pxToRem('1px')} rgba(70, 122, 251, 0.56)`};
  background-color: #fff;
  margin: ${pxToRem('20px')} 0;
  outline: none;
  font-family: ${({ theme }) => theme.fontset.opensans};
`;
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const ButtonCloseLead = styled.div`
  margin-top: ${pxToRem('60px')};
  gap: ${pxToRem('20px')};
`;
export const ItemContainer = styled.div`
  padding-top: ${pxToRem('10px')};
`;

export const TitleContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: ${pxToRem('10px')};
  span {
    display: block;
  }
`;

export const AcceptButtonContainer = styled.div`
  margin: ${pxToRem('40px')} auto ${pxToRem('20px')} auto;
  display: flex;
  justify-content: center;

  input {
    min-width: ${pxToRem('240px')};
    min-height: ${pxToRem('48px')};
    padding: ${pxToRem('16px')} ${pxToRem('32px')};
    border-radius: ${pxToRem('27px')};
    color: ${({ theme }) => theme.colors.white};
    background-image: linear-gradient(79deg, #00d7a3, #00d7ca 54%, #00d7a3);
    margin-left: ${pxToRem('10px')};
    border: none;

    font-weight: bold;
    font-family: OpenSans;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: ${pxToRem('1.4px')};
    text-align: center;
    font-size: ${pxToRem('14px')};
    text-transform: uppercase;
    :disabled {
      background-image: none !important;
      background-color: ${({ theme }) => theme.colors.fadedGray};
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const BoxSelectLeadType = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${pxToRem('320px')};
  height: ${pxToRem('104px')};
  border: ${props =>
    props.selectedType
      ? `${pxToRem('3px')} solid ${props.theme.colors.mainBlue}`
      : `${pxToRem('3px')} solid ${props.theme.colors.lightGray3}`};
  border-radius: ${pxToRem('16px')};
  cursor: pointer;
  transition: 0.4s;

  &:hover {
    box-shadow: 0 ${pxToRem('40px')} ${pxToRem('32px')} -${pxToRem('16px')} ${props => props.theme.colors.black.five};
  }

  & > img {
    width: ${pxToRem('24px')};
    margin-right: ${pxToRem('32px')};
  }
`;

export const GoBackContainer = styled.span`
  position: absolute;
`;

export const CreateLeadForm = styled.form`
  width: 100%;
`;

export const MaxHeightBox = styled.div`
  max-height: ${pxToRem('550px')};
  overflow-y: auto;
`;

export const PhoneSection = styled.div`
  border-radius: ${pxToRem('6px')};
  height: ${pxToRem('59px')};

  ${props =>
    props.status === 'invalid'
      ? props.theme.colors.redError
      : 'rgba(255, 255, 255, 0.8)'};
  background-color: rgba(255, 255, 255, 0.32);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: ${pxToRem('10px')};
  width: ${pxToRem('431px')};
  margin: ${pxToRem('10px')};
  gap: ${pxToRem('10px')};

  & > div {
    height: ${pxToRem('56px')};
  }
/*
  div:nth-child(1) {
    width: ${pxToRem('150px')};
    div {
      width: unset;
     min-width: unset;
    }
  }*/
/*
  div:nth-child(2) {
    width: ${props =>
      props.showSecondNumber
        ? `calc(${pxToRem('431px')} - ${pxToRem('150px')})`
        : `calc(${pxToRem('431px')} - ${pxToRem('150px')} - ${pxToRem(
            '100px'
          )})`};
*/

    ${props =>
      props.showSecondNumber &&
      css`
        margin-right: 0;
      `}
    input {
      width: 100%;
    }
  }

  .addField {
    width: ${props => pxToRem(`${props.addWidth + 50}px`)};
  }

  .remField {
    width: ${props => pxToRem(`${props.remWidth + 50}px`)};
  }
`;

export const AddPhone = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${pxToRem('100px')};
  padding: ${pxToRem('15px')};
  border-left: ${pxToRem('1px')} solid ${props => props.theme.colors.lightGray2};
  color: ${props => props.theme.colors.aquamarine};

  width: ${props => pxToRem(`${props.remWidth + 50}px`)};

  & > div:is(:first-child) {
    margin-right: ${pxToRem('10px')};
  }
`;

export const loadWidth = props => {
  let style;
  switch (props.split) {
    case '1/2':
      style = css`
        & > div {
          width: 50%;
          margin: 0;
        }
      `;
      break;
    case '2/3':
      style = css`
        & > div {
          &:is(:first-child) {
            width: 75%;
            margin: 0;
          }
          &:is(:not(:first-child)) {
            width: 25%;
            margin: 0;

            input {
              width: 100%;
            }
          }
        }
      `;
      break;
    default:
      break;
  }

  return style;
};

export const Row = styled.div`
  max-width:${pxToRem('431px')};
  min-height:${pxToRem('56px')};
  margin: ${pxToRem('10px')};
  display: flex;
  flex-direction: row;
  ${props =>
    !props.noFlex &&
    css`
      align-items: flex-start;
    `}
  gap: ${pxToRem('13px')}
  justify-content: space-between;
  select {
    width: ${pxToRem('431px')};
  }
  & > div {
    width: ${pxToRem('431px')};
  }
  
  
  ${props =>
    props.split &&
    css`
      width: ${pxToRem('431px')};
      ${loadWidth(props)}
    `}
  
  ${props =>
    props.clickable &&
    css`
      cursor: pointer;
    `}
`;

export const DownloadRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.mainBlue};
  font-size: ${pxToRem('14px')};
  gap: ${pxToRem('40px')};

  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: ${pxToRem(`${marginTop}px`)};
    `}
`;

export const DownloadSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  & > a {
    color: ${props => props.theme.colors.mainBlue};
    &:is(:first-child) {
      margin-right: ${pxToRem('14px')};
    }

    & > div {
      margin-right: ${pxToRem('8px')};
    }
  }
  & > div:is(:first-child) {
    margin-right: ${pxToRem('14px')};
  }
`;

export const DragDropContainer = styled.div`
  width: 100%;

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    & > div {
      width: 100%;
    }
  }
`;

export const ProceedButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${pxToRem('40px')};
`;

export const VehicleSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${pxToRem('24px')} 0;
  margin: ${pxToRem('24px')} 0;
  border-top: ${pxToRem('1px')} solid ${props => props.theme.colors.lightGray3};
  border-bottom: ${pxToRem('1px')} solid
    ${props => props.theme.colors.lightGray3};
`;

export const VehicleSectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 0 ${pxToRem('8px')};
  cursor: pointer;
`;
export const VehicleTitleLeftSection = styled.div`
  display: flex;
  align-items: center;

  span {
    margin-left: ${pxToRem('16px')};
  }
`;

export const VehicleTitleRightSection = styled.div``;

export const VehicleContent = styled.div`
  max-height: ${props => (props.isOpen ? `${pxToRem('300px')}` : '0')}
  transition: all 0.3s ease-in-out;
`;

export const CloseLeadContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: ${pxToRem('56px')};
  gap: ${pxToRem('24px')};
  align-items: center;
  overflow-y: auto;
  //overflow-x: hidden;
`;

export const ExistingLead = styled.span`
  cursor: pointer;
  color: ${props => props.theme.colors.mainBlue};
`;

export const LoaderContainer = styled.div`
  min-width: ${pxToRem('240px')};
  min-height: ${pxToRem('48px')};
  padding: ${pxToRem('16px')} ${pxToRem('32px')};
  border-radius: ${pxToRem('27px')};
  color: ${({ theme }) => theme.colors.white};
  //background-image: linear-gradient(79deg, #00d7a3, #00d7ca 54%, #00d7a3);
  margin-left: ${pxToRem('10px')};
  border: none;
`;
